module.exports = __webpack_public_path__ + "static/media/deer-rudolph.2cc0c6bc.svg";